import { render, staticRenderFns } from "./StepDispathcer.vue?vue&type=template&id=118eddc0&scoped=true"
import script from "./StepDispathcer.vue?vue&type=script&lang=ts"
export * from "./StepDispathcer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118eddc0",
  null
  
)

export default component.exports